import { createContext, useContext, useMemo } from 'react';

const AgentKnowledgeEnvContext = createContext(null);

function readWorkspaceUuid() {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem('workspace_uuid');
}

function readUserUuid() {
  if (typeof window === 'undefined') return '';
  return localStorage.getItem('user_uuid') || '';
}

/** Agent + auth env for Knowledge tab (replaces ann-web-app AgentContext slice). */
export function AgentKnowledgeEnvProvider({ agent, userId, children }) {
  const value = useMemo(() => {
    const tenantId = agent?.tenantId ?? readWorkspaceUuid() ?? null;
    const resolvedUserId = userId || readUserUuid();
    return {
      agent,
      agentId: agent?.id ?? null,
      vaultUuid: agent?.vaultUuid ?? null,
      userId: resolvedUserId,
      tenantId,
    };
  }, [agent, userId]);

  return (
    <AgentKnowledgeEnvContext.Provider value={value}>{children}</AgentKnowledgeEnvContext.Provider>
  );
}

export function useAgentKnowledgeEnv() {
  const ctx = useContext(AgentKnowledgeEnvContext);
  if (!ctx) {
    throw new Error('useAgentKnowledgeEnv must be used within AgentKnowledgeEnvProvider');
  }
  return ctx;
}

export default AgentKnowledgeEnvContext;
